import { captureException } from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { Topology } from 'topojson-specification';

import { leadingZeroFIPS } from '../helpers';
import { StateId } from '../types';

async function fetchGeography(stateFips: StateId, signal: AbortSignal) {
	if (!stateFips) return;
	try {
		const response = await fetch(
			`/data/states/${leadingZeroFIPS(stateFips)}.json`,
			{ signal },
		);
		const data = await response.json();
		return data as Topology;
	} catch (error) {
		console.error(error);
		captureException(error);
		throw error;
	}
}

export function useStateGeography(stateFips: StateId) {
	const { data, isLoading, error } = useQuery({
		queryKey: ['geography', stateFips],
		queryFn: async ({ signal }) => fetchGeography(stateFips, signal),
	});

	return {
		geography: data,
		geographyLoading: isLoading,
		geographyError: error,
	};
}
